// export const BASE_URL = "https://dev.siyaram.com/nirman/api/";
export const BASE_URL = "https://sumaglobal.siyaram.com/nirman/api/";

const TIMEOUT_DURATION = 5000;

export const setBaseUrl = (server) => {
  console.log(server);
};

import Swal from "sweetalert2";

const showAlert = async (error) => {
  const swalResult = await Swal.fire({
    title: "Error",
    text: error,
    icon: "error",
    confirmButtonText: "Okay",
    customClass: "sweetalert-bootstrap-modal",
    timer: 2000,
    showConfirmButton: false,
  });

  // If you want to perform some action after the alert is closed, you can check the result
  if (swalResult.dismiss === Swal.DismissReason.timer) {
  }
};

const handleApiResponse = async (response) => {
  if (!response.ok) {
    return;
  }

  return await response.json();
};

const handleNetworkError = (error) => {
  console.error("Check Error :" + error);
  if (error.message.includes("Failed to fetch")) {
    showAlert(
      "It seems that the connection to server has been lost. Please check your network connectivity and server status."
    );
    return;
  } else {
    showAlert(`Error fetching data: ${error.message}`);
    return;
  }
};

// const json_api = (url, payload) => {
//   return fetch(BASE_URL + url, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(payload),
//   }).then((res) => res.json());
// };

const bodycontent = (body, url) => {
  if (!navigator.onLine) {
    throw new Error("No internet connection. Please check your network settings.");
  }
  return fetch(BASE_URL + url, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: body,
    timeout: TIMEOUT_DURATION,
  });
};

const uplaodbodycontent = (body, url) => {
  if (!navigator.onLine) {
    throw new Error("No internet connection. Please check your network settings.");
  }
  return fetch(BASE_URL + url, {
    method: "POST",
    body: JSON.stringify(body),
  });
};

// Download file
const downloadFiles = async (param, url, filename) => {
  try {
    const response = await fetch(BASE_URL + url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: param,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const loginApi = async (userCode, password) => {
  try {
    const response = await bodycontent(
      `userCode=${userCode}&password=${password}&source=${"web"}`,
      "vendor/login.php"
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch vendor PO
const fetchVendorPO = async (
  vendorCode,
  poNumber = "",
  fromDate = "",
  toDate = "",
  page = 1,
  limit = 50
) => {
  try {
    // Calculate offset
    const offset = (page - 1) * limit;

    // Build query string
    let query = `vendorCode=${vendorCode}&offset=${offset}&limit=${limit}`;
    if (poNumber) query += `&poNumber=${encodeURIComponent(poNumber)}`;
    if (fromDate) query += `&fromDate=${encodeURIComponent(fromDate)}`;
    if (toDate) query += `&toDate=${encodeURIComponent(toDate)}`;

    // Call API
    const response = await bodycontent(query, "vendor/getvendorPObyId.php");

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch vendor ledger
const fetchVendorLedger = async (vendorCode) => {
  try {
    const response = await bodycontent(`vendorCode=${vendorCode}`, "vendor/vendorledger.php");

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch vendor ledger details
const fetchVendorLedgerDetails = async (vendorCode, month, year, opening) => {
  try {
    const response = await bodycontent(
      `vendorCode=${vendorCode}&opening=${opening}&month=${month}&year=${year}`,
      "vendor/vendorledgerDetails.php"
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch vendor ledger details
const fetchBarcodeDetails = async (vendorCode, PONumber, barcodes, boxNumber) => {
  // try {
  //   const response = await bodycontent(`barcodes=${barcodes}`, "vendor/fetchBarcodesData.php");

  //   return await handleApiResponse(response);
  // } catch (error) {
  //   throw handleNetworkError(error);
  // }

  try {
    const data = [
      {
        vendorCode: vendorCode,
        PONumber: PONumber,
        barcodes: barcodes,
        boxNumber: boxNumber,
      },
    ];

    const response = await uplaodbodycontent(data, "vendor/fetchASNBarcodesData.php");

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Upload ASN data
const uploadASN = async (ASNData) => {
  try {
    const response = await uplaodbodycontent(ASNData, "vendor/ASNDataUpload.php");

    return await handleApiResponse(response);
  } catch (error) {
    console.log(error);
    throw handleNetworkError(error);
  }
};

// Get ASN Status date
const getAllASnStatusData = async (vendorCode, searchPONumber, page, pageSize) => {
  try {
    const response = await bodycontent(
      `vendorCode=${vendorCode}&poNumber=${searchPONumber}&offset=${
        page * pageSize
      }&limit=${pageSize}`,
      // "Admin/vendorasnlist.php"
      "vendor/vendorasnlist.php"
    );

    console.error("Response:", response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Get GRN data
const fetchGRNStatusData = async (vendorCode, poNumber = "", page = 1, limit = 50) => {
  try {
    const offset = (page - 1) * limit;
    let query = `vendorCode=${vendorCode}&offset=${offset}&limit=${limit}`;
    if (poNumber) query += `&poNumber=${poNumber}`;
    const response = await bodycontent(query, "vendor/getGRNDataByVendorID.php");

    console.error("Response:", response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch latest box number for ASN upload
const fetchBoxNumber = async (vendorCode, PONumber) => {
  try {
    const response = await bodycontent(
      `vendorCode=${vendorCode}&PONumber=${PONumber}`,
      "vendor/getBoxNumber.php"
    );

    console.error("Response:", response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Download ASN data
const ASNDataDownload = async (PONumber, vendorCode, boxNumber) => {
  try {
    const response = await fetch(BASE_URL + "pdf/ASN_data_pdf.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: `PONumber=${PONumber}&vendorCode=${vendorCode}&boxNumber=${boxNumber}`,
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    // console.log(response);
    const blob = await response.blob();

    // Create a link element and trigger a download
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = PONumber + "-" + boxNumber + ".pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return true;
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Fetch latest box number for ASN upload
const fetchBoxNumberByVendor = async (PONumber, vendorCode) => {
  try {
    const response = await bodycontent(
      `vendorCode=${vendorCode}&PONumber=${PONumber}`,
      "vendor/fetchBoxNumbersByVendor.php"
    );

    console.error("Response:", response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Upload Bill Data
const uploadBillDetailsAPI = async (billData) => {
  console.log(billData);
  try {
    const response = await uplaodbodycontent(billData, "vendor/uploadASNBillDetails.php");

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Stagging --------------
// Fetch Total PO Quantity

const fetchStages = async (vendorCode, PONumber, stagesgroupid) => {
  try {
    const response = await bodycontent(
      `vendor_code=${vendorCode}&po_number=${PONumber}&stage_group=${stagesgroupid}`,
      "vendor/fetchstages.php"
    );

    console.error("Response:", response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchStageGroups = async (vendorVertical,ponumber) => {
  try {
    const response = await bodycontent(
      `stage_vertical=${vendorVertical}&po_number=${ponumber}`,
      "vendor/getstagesgroups.php"
    );

    console.error("Response:", response);

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const postStagesData = async (vendorCode, vendorName, PONumber, PODate, totalqty, stages) => {
  try {
    const stagesJson = JSON.stringify(stages);
    const response = await bodycontent(
      `vendor_code=${vendorCode}&vendor_name=${vendorName}&po_number=${PONumber}&po_date=${PODate}&totalqty=${totalqty}&stages=${stagesJson}`,
      "vendor/insertstages.php"
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

const fetchDashboardData = async (vendorCode) => {
  try {
    const response = await bodycontent(
      `vendorCode=${vendorCode}`,
      "vendor/getVendorDashboardCount.php"
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Forgot Password
const forgotPassApi = async (vendorCode, mobile) => {
  try {
    const response = await bodycontent(
      `vendorCode=${vendorCode}&mobile=${mobile}`,
      "vendor/otpgeneration.php"
    );
    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// OTP Verification API
const otpVerificaionApi = async (mobile, vendorCode, otp) => {
  try {
    const response = await bodycontent(
      `mobileNo=${mobile}&vendorCode=${vendorCode}&otp=${otp}`,
      "vendor/otpverify.php"
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

// Reset Password API
const resetPasswordApi = async (vendorCode, newPassword) => {
  try {
    const response = await bodycontent(
      `vendorCode=${vendorCode}&newPassword=${newPassword}`,
      "vendor/resetpassword.php"
    );

    return await handleApiResponse(response);
  } catch (error) {
    throw handleNetworkError(error);
  }
};

export {
  loginApi,
  forgotPassApi,
  fetchVendorPO,
  fetchVendorLedger,
  fetchVendorLedgerDetails,
  downloadFiles,
  fetchBarcodeDetails,
  uploadASN,
  getAllASnStatusData,
  fetchGRNStatusData,
  fetchBoxNumber,
  ASNDataDownload,
  fetchBoxNumberByVendor,
  uploadBillDetailsAPI,
  fetchStageGroups,
  fetchStages,
  postStagesData,
  fetchDashboardData,
  otpVerificaionApi,
  resetPasswordApi,
};
